import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const GlobalPresence = () => {
  return (
    <>
      <SEO 
        title="Global Presence - Abacies Logiciels Worldwide"
        description="Abacies Logiciels operates globally, supporting clients around the world with AI solutions, custom software development, and digital transformation services across multiple countries and regions."
        keywords="global presence, worldwide operations, international presence, global technology partner, Abacies locations"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Global Presence
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Global Presence page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Global Presence. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default GlobalPresence;
